export default "__VITE_ASSET__BJlcLn_s__"